'use client';
import { useRouter, useSearchParams } from 'next/navigation';

export default function SortBar() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const params = new URLSearchParams(searchParams.toString());
    if (e.target.value) params.set('sort', e.target.value);
    else params.delete('sort');
    router.push(`/?${params.toString()}`);
  }

  return (
    <div className="noir-panel flex flex-wrap items-center gap-x-8 gap-y-4 px-5 py-4">
      <div className="flex items-center gap-3">
        <label className="noir-label" style={{ margin: 0 }}>Třídit</label>
        <select
          onChange={handleSortChange}
          defaultValue={searchParams.get('sort') || ''}
          className="noir-field"
          style={{ width: 'auto' }}
        >
          <option value="">Náš výběr</option>
          <option value="newest">Nejnovější</option>
          <option value="price_asc">Od nejlevnějšího</option>
          <option value="price_desc">Od nejdražšího</option>
        </select>
      </div>
    </div>
  );
}
